import(/* webpackMode: "eager" */ "/workspace/.ci/web-hosting-src/app/page.tsx");
